import { createAsyncThunk } from "@reduxjs/toolkit";

import { isErrorResult, makeApiRequest, ENDPOINTS_PROOF } from "services";

import { ErrorResult } from "services/types";
import { CheckAgoricProofPayload } from "./types";
import { ProofPayload, TokenProofResponse } from "../solana-proof/types";

export const checkAgoricProof = createAsyncThunk<
  TokenProofResponse,
  CheckAgoricProofPayload,
  { rejectValue: ErrorResult }
>("zkp/check-agoric-proof", async (data, { rejectWithValue }) => {
  const result = await makeApiRequest<TokenProofResponse>({
    method: "POST",
    url: ENDPOINTS_PROOF.checkAgoricProof,
    data,
  });

  if (isErrorResult(result)) {
    return rejectWithValue(result);
  }

  return result;
});

export const getProof = createAsyncThunk<ProofPayload, undefined, { rejectValue: ErrorResult }>(
  "zkp/get-proof",
  async (_, { rejectWithValue }) => {
    const result = await makeApiRequest<ProofPayload>({
      method: "POST",
      url: ENDPOINTS_PROOF.getProofPayload,
    });

    if (isErrorResult(result)) {
      return rejectWithValue(result);
    }

    return result;
  },
);
